import createIcon from '../../createIcon';

/**
 * @component @name Merge
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi40MSAyMUw1IDE5LjU5TDkuODMgMTQuNzZDMTAuNTggMTQuMDEgMTEgMTIuOTkgMTEgMTEuOTNWNi44M0w5LjQxIDguNDFMOCA3TDEyIDNMMTYgN0wxNC41OSA4LjQxTDEzIDYuODNWMTEuOTNDMTMgMTIuOTkgMTMuNDIgMTQuMDEgMTQuMTcgMTQuNzZMMTkgMTkuNTlMMTcuNTkgMjFMMTIgMTUuNDFMNi40MSAyMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Merge = createIcon('Merge', [
  [
    'path',
    {
      d: 'M6.41 21L5 19.59L9.83 14.76C10.58 14.01 11 12.99 11 11.93V6.83L9.41 8.41L8 7L12 3L16 7L14.59 8.41L13 6.83V11.93C13 12.99 13.42 14.01 14.17 14.76L19 19.59L17.59 21L12 15.41L6.41 21Z',
      key: '6sxgme',
    },
  ],
]);

export default Merge;
